module.exports = "/images/flood@3x.png?fa4fd7cdf977d9735fe12b5fbda90a84";